import { type PluginListenerHandle, registerPlugin } from "@capacitor/core";

// Kept apart from `screenZoom`, which reads device preferences, so the window store can listen
// to it without importing the rest of the app.

interface ScreenZoomPlugin {
  isSupported(): Promise<{ value: boolean }>;
  set(options: { enabled: boolean }): Promise<void>;
  /** After the window has been resized for the zoom, or back, which moves its safe area. */
  addListener(event: "applied", listener: () => void): Promise<PluginListenerHandle>;
}

/** iOS only: draws the whole window on an iPad as an enlarged iPhone 18 Pro, one pane. */
export const ScreenZoom = registerPlugin<ScreenZoomPlugin>("ScreenZoom");
